import {
    styled,
    TextFieldProps,
    TextField,
    Box,
} from "@mui/material"
import React, { forwardRef } from "react"

export type CustomTextFieldProps = TextFieldProps & {
    bgcolor?: string
    endIcon?: React.ReactNode;
}

export const CustomTextField = styled(TextField, {
    shouldForwardProp: (prop) => prop !== "bgcolor",
})<CustomTextFieldProps>(({ theme, bgcolor = "white" }) => ({
    color: theme.palette.grey[400],
    "& .MuiFilledInput-root, & .MuiFilledInput-root:hover": {
        transition: "border 0.2s ease-in-out",
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: bgcolor,
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
    },
    "& .MuiFilledInput-root.Mui-focused": {
        transition: "border 0.2s ease-in-out",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: bgcolor,
    },
    "& .MuiFormLabel-root.Mui-focused:not(.Mui-error)": {
        color: theme.palette.grey[400],
    },
    "&:hover .MuiFilledInput-root:not(.Mui-disabled)": {
        transition: "border 0.2s ease-in-out",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    "& .MuiSelect-select:focus": {
        backgroundColor: bgcolor,
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
    },
}))

export const StyledTextField = forwardRef(
    ({ endIcon, ...props }: CustomTextFieldProps, ref) => {
        const textField = (
            <CustomTextField
                variant="filled"
                fullWidth
                slotProps={{
                    input: {
                        disableUnderline: true,
                    },
                }}
                {...props}
                inputRef={ref}
            />
        );

        if (!endIcon) {
            return textField;
        }

        return (
            <Box sx={{ position: "relative", width: "100%" }}>
                {textField}
                <Box
                    sx={(theme) => {
                        const tf = (theme).palette?.textfield ?? {
                            default: theme.palette.primary.main,
                            disabled: theme.palette.grey[400],
                        }
                        return {
                            position: "absolute" as const,
                            right: 5,
                            top: "25%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                            pointerEvents: "none" as const,
                            color: tf[props.disabled ? "disabled" : "default"],
                        }
                    }}
                >
                    {endIcon}
                </Box>
            </Box>
        );
    })
